// extracted by mini-css-extract-plugin
export const root = "bd_r";
export const paper = "bd_s";
export const title = "bd_x";
export const btnUpdate = "bd_w";
export const titleSection = "bd_S";
export const subtitleSection = "bd_ct";
export const subtitle = "bd_cv";
export const form = "bd_t";
export const input = "bd_g";
export const chipInput = "bd_cw";
export const inputFile = "bd_v";
export const errorMsg = "bd_m";
export const profileImage = "bd_y";
export const profileSection = "bd_z";
export const btnUpload = "bd_B";
export const passwordTitle = "bd_C";
export const subTitle = "bd_cp";